import type { ReactNode } from 'react';

interface Props {
  title: string;
  subtitle?: string;
  children: ReactNode;
  /** Classe supplémentaire (ex. `dos-carte`, carte plus large du questionnaire de dossier). */
  className?: string;
}

export function AuthCard({ title, subtitle, children, className }: Props) {
  return (
    <section className={className ? `auth-card ${className}` : 'auth-card'}>
      <h1>{title}</h1>
      {subtitle ? <p className="subtitle">{subtitle}</p> : null}
      {children}
    </section>
  );
}
